// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3F_ok","file":"styles_file__3nJyA"};